import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { RolodexEntryJson, RolodexEntryTagsType, RolodexEntryType } from 'types'

export interface IndicationRecommendation {
  id: string
  title: string
  author: string
  content: string
}

export const RD_TYPE_INDICATION_REC = RolodexEntryType.INDICATION_RECOMMENDATION

type RolodexIndicationRecommendation = IndicationRecommendation & {
  tags: RolodexEntryTagsType
}

// Converts Rolodex Entry into Indication Recommendation
function entryToIndicationRecommendation(
  entry: RolodexEntryJson
): RolodexIndicationRecommendation {
  return {
    id: entry.id,
    title: entry.data.title as string,
    author: entry.data.author as string,
    content: entry.data.content as string,
    tags: entry.tags,
  }
}

export function useIndicationRecommendations(
  indicationId: string | undefined
): {
  recs: ReadonlyArray<IndicationRecommendation>
  isLoading: boolean
} {
  const roiQuery = useMemo(
    () =>
      indicationId
        ? [
            {
              type: RD_TYPE_INDICATION_REC,
              tags: {
                indication: indicationId,
              },
            },
          ]
        : [],
    [indicationId]
  )

  const { entries, isLoading } = useRolodexEntries(roiQuery)
  return useMemo(
    () => ({
      recs: entries.map(entryToIndicationRecommendation),
      isLoading,
    }),
    [entries, isLoading]
  )
}
